import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_vm.historyDialog ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.historyDialog,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        _vm.historyDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistory')) + "\n    ")];
      },
      proxy: true
    }], null, false, 89683544)
  }, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-date-time-picker', {
    staticClass: "mt-0",
    attrs: {
      "from": _vm.historyQueryStartDate / 1000,
      "to": _vm.historyQueryEndDate / 1000,
      "isRange": ""
    },
    on: {
      "date:picked": _vm.handleDatePicked
    }
  })], 1), _c(VDataTable, {
    attrs: {
      "headers": _vm.executionHistoryTableHeaders,
      "footer-props": _vm.executionHistoryTableFooter,
      "items": _vm.executionHistory,
      "server-items-length": _vm.executionHistoryItemsLength,
      "options": _vm.executionHistoryTableOptions,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.executionHistoryTableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.execErrors",
      fn: function ({
        item
      }) {
        return [_c('custom-code', [_vm._v(_vm._s(_vm.get(item, 'error', '-')))])];
      }
    }, {
      key: "item.date",
      fn: function ({
        item
      }) {
        return [_vm._v("\n        " + _vm._s(_vm.localizeDate(item.date)) + "\n      ")];
      }
    }, {
      key: "expanded-item",
      fn: function ({
        headers,
        item
      }) {
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [_c('codemirror', {
          attrs: {
            "options": _vm.cmOptions,
            "value": JSON.stringify(item.properties, null, 1)
          }
        })], 1)];
      }
    }], null, false, 883492245)
  })], 1) : _vm._e(), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.drawer.dTwinRulesMonitor'),
      "subtitle": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.errorRulesMonitorText')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.home.favorites'),
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.favouriteFilter = !_vm.favouriteFilter;
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(_vm._s(_vm.favouriteFilter ? 'fas' : 'fal') + " fa-star")])], 1), _c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12",
      "md": "4",
      "align": "right"
    }
  }, [_c(VSwitch, {
    attrs: {
      "inset": "",
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.includeVDRules')
    },
    model: {
      value: _vm.includeVDRules,
      callback: function ($$v) {
        _vm.includeVDRules = $$v;
      },
      expression: "includeVDRules"
    }
  })], 1), _c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalized.headers,
      "items": _vm.list,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableLocalized.footerProps,
      "item-key": "id"
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination]
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', [_c('div', {
          staticStyle: {
            "margin": "0 auto",
            "text-align": "center"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": props.item.properties.disabled ? 'primary' : _vm.color,
            "size": "16"
          }
        }, [_vm._v("\n                    fal fa-lightbulb" + _vm._s(props.item.properties.disabled ? '-slash' : '') + "\n                  ")])], 1)]), _c('td', {
          staticClass: "text-left",
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "260px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.properties.title) + "\n              ")]), _c('td', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.detailButtonClicked(props.item);
            }
          }
        }, [_vm._v("fal fa-eye")])], 1), _c('td', [_vm._v("\n                " + _vm._s(props.item.dtwin.title) + "  \n                "), _c('a', {
          attrs: {
            "href": `/#${_vm.baseDetailLink(props.item)}`,
            "target": "_blank"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("fal fa-external-link")])], 1)]), _c('td', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionHistory'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openExecutionHistoryDialog(props.item);
            }
          }
        }, [_vm._v("\n                  fal fa-clock\n                ")])], 1), _c('td', [_vm._v("\n                " + _vm._s(_vm.localizeDate(_vm.get(props.item, 'errorExec.date') || null)) + "\n              ")]), _c('td', {
          staticStyle: {
            "max-width": "250px"
          }
        }, [_c('custom-code', [_vm._v(_vm._s(_vm.get(props.item, 'errorExec.error', '-')))])], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.lines')) + " " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n            " + _vm._s(props.itemsLength) + "\n          ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };